import { AppAreaConfig } from '@/funnels/@types'

type FunnelGroup = {
	id: string
	name: string
	appAreas: AppAreaConfig[]
}

export const FUNNEL_GROUPS: FunnelGroup[] = [
	{
		id: 'fasting',
		name: 'Fasting',
		appAreas: [
			require('./fasting/female').default,
			require('./fasting/male').default,
			require('./fasting/main').default,
		],
	},
	{
		id: 'yoga',
		name: 'Yoga',
		appAreas: [
			require('./yoga/activity-female-yoga').default,
			require('./yoga/activity-male-chair-workouts').default,
			require('./yoga/main-yoga').default,
		],
	},
	{
		id: 'walking',
		name: 'Walking',
		appAreas: [
			require('./walking/activity-female-walking').default,
			require('./walking/activity-male-walking').default,
			require('./walking/female-printable-walking').default,
			require('./walking/main-walking').default,
		],
	},
	{
		id: 'pilates',
		name: 'Pilates',
		appAreas: [
			require('./pilates/activity-female-pilates').default,
			require('./pilates/activity-female-senior-pilates').default,
		],
	},
	{
		id: 'activity',
		name: 'Activity',
		appAreas: [
			require('./activity/activity-female-v2').default,
			require('./activity/activity-male').default,
			require('./activity/main-activity').default,
		],
	},
	{
		id: 'tai-chi',
		name: 'Tai Chi',
		appAreas: [
			require('./tai-chi/activity-female-tai-chi').default,
			require('./tai-chi/activity-female-tai-chi-walking').default,
			require('./tai-chi/activity-female-tai-chi-walking-v2').default,
			require('./tai-chi/activity-female-tai-chi-walking-pr').default,
			require('./tai-chi/activity-male-tai-chi-walking').default,
			require('./tai-chi/activity-male-tai-chi-yoga').default,
			require('./tai-chi/main-tai-chi').default,
			require('./tai-chi/main-tai-chi-walking').default,
		],
	},
	{
		id: 'glp',
		name: 'GLP',
		appAreas: [require('./glp/female-glp').default],
	},
	{
		id: 'calisthenics',
		name: 'Calisthenics',
		appAreas: [
			require('./calisthenics/activity-female-calisthenics').default,
			require('./calisthenics/activity-male-calisthenics').default,
			require('./calisthenics/main-calisthenics').default,
		],
	},
	{
		id: 'japanese-walking',
		name: 'Japanese Walking',
		appAreas: [
			require('./japanese-walking/activity-female-walking-japanese').default,
			require('./japanese-walking/activity-female-walking-japanese-v2').default,
		],
	},
	{
		id: 'asian-pilates',
		name: 'Asian Pilates',
		appAreas: [require('./asian-pilates/activity-female-asian-pilates').default],
	},
	{
		id: 'military',
		name: 'Military',
		appAreas: [require('./military/military-male').default],
	},
	{
		id: 'water-fasting',
		name: 'Water Fasting',
		appAreas: [require('./water-fasting/female-water-balance').default],
	},
	{
		id: 'diets',
		name: 'Diets',
		appAreas: [
			require('./diets/female-cortisol-diet').default,
			require('./diets/female-menopause-diet').default,
			require('./diets/female-mediterranean-diet').default,
		],
	},
	{
		id: 'applovin',
		name: 'AppLovin',
		appAreas: [
			require('./applovin/activity-female-pilates-al').default,
			require('./applovin/activity-female-walking-al').default,
			require('./applovin/activity-female-yoga-al').default,
			require('./applovin/female-al').default,
			require('./applovin/activity-female-tai-chi-walking-al').default,
			require('./applovin/activity-female-tai-chi-walking-v2-al').default,
		],
	},
	{
		id: 'other',
		name: 'Other',
		appAreas: [
			require('./other/assessment').default,
			require('./other/call').default,
			require('./other/together').default,
			require('./other/workbooks').default,
		],
	},
]

export const APP_AREAS: AppAreaConfig[] = FUNNEL_GROUPS.flatMap((group) => group.appAreas)
